<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
import vFooter from "./components/footer";
export default {
  name: "app",
  components: {
    vFooter,
  },
};
</script>

<style>
@import url(./assets/css/global.css);

html,
body {
  margin: 0;
  padding: 0;
  font-family: "微软雅黑";
}
em {
  font-style: normal;
}
#app {
  /* background: url("assets/img/bg.png"); */
  width: 100%;
  /* height: 100%; */
  /* background-size: 100% 100%; */
  background-repeat: no-repeat;
  overflow: visible;
}
#nprogress .bar {
  /* background: red !important; */
  height: 7px !important;
}
</style>
